/*
    缓存vnode节点
*/
export default (tabManager) => {
    return {
        name: 'AliveTab',
        abstract: true,
        props: {},
        data: () => ({
            tabs: tabManager.tabs,
            cache: {},
        }),
        computed: {},

        watch: {
            // 缓存栈跟着tabs走
            tabs(list) {
                for (var key in this.cache) {
                    // 将不在栈中的缓存清除
                    if (list.findIndex(t => t.key == key) < 0) {
                        const vnode = this.cache[key]
                        vnode && vnode.componentInstance.$destroy()
                        delete this.cache[key]
                    }
                }
            },
        },
        destroyed() {
            for (const key in this.cache) {
                const vnode = this.cache[key]
                vnode && vnode.componentInstance.$destroy()
            }
        },
        render() {
            const vnode = this.$slots.default ? this.$slots.default[0] : null
            var needCaching = tabManager.options.defaultCache

            if (this.$route.meta && ('keepAlive' in this.$route.meta)) {
                needCaching = !!this.$route.meta.keepAlive
            }

            // 需要缓存
            if (needCaching && vnode) {
                // vnode如果是组件，则其tag是唯一的
                vnode.key = vnode.key || (vnode.isComment ?
                    'comment' :
                    vnode.tag)
                
                // prevent vue-router reuse component
                // 路由实例标识
                const key = tabManager.getRouteKey(this.$route)
                const $tab = tabManager.getTab(key)

                // 是否记录过路由
                if (vnode.key.indexOf(key) === -1) {
                    // 组件实例唯一
                    vnode.key = `__tab_cache-${key}-${vnode.key}`
                }

                if (this.cache[key]) {
                    if (vnode.key === this.cache[key].key) {
                        // restore vnode from cache
                        vnode.componentInstance = this.cache[key].componentInstance
                    } else {
                        // replace vnode to cache
                        this.cache[key].componentInstance.$destroy()
                        this.cache[key] = vnode
                    }
                } else {
                    // cache new vnode
                    this.cache[key] = vnode
                }

                vnode.data.keepAlive = true
                $tab.cached = true
            }

            // 一般而言，render会在子组件实例初始化之前执行，除了一种特殊情况，子组件是默认子路由（cache会在created之后）。
            // console.log("alive-tab render")

            return vnode
        }
    }
}